'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleScroll = exports.getTouchY = undefined;

var _utils = require('./utils');

var getTouchY = exports.getTouchY = function getTouchY(event) {
  return event.changedTouches[0].clientY;
};

var handleScroll = exports.handleScroll = function handleScroll(endTarget, event, sourceDelta) {
  var preventOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var delta = sourceDelta;
  // find scrollable target
  var target = event.target;


  var shouldCancelScroll = false;
  var isDeltaPositive = delta > 0;

  var availableScroll = 0;
  var availableScrollTop = 0;

  do {
    var _target = target,
        scrollTop = _target.scrollTop,
        scrollHeight = _target.scrollHeight,
        clientHeight = _target.clientHeight;


    availableScroll += scrollHeight - clientHeight - scrollTop;
    availableScrollTop += scrollTop;

    target = target.parentNode;
  } while (endTarget.contains(target));

  if (isDeltaPositive && delta > availableScroll) {
    shouldCancelScroll = true;
  } else if (!isDeltaPositive && -delta > availableScrollTop) {
    shouldCancelScroll = true;
  }

  // cancel scroll
  if (shouldCancelScroll) {
    if (preventOnly) {
      (0, _utils.preventDefault)(event);
    } else {
      (0, _utils.preventAll)(event);
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-locky/dist/handleScroll.js
// module id = 963
// module chunks = 58